import {ClientLineItem} from "@/shared/services/basket/ClientLineItem.ts";
import {BasketCost, BasketPromotionsInput, BasketValidation, Contact, PromotionResponse} from "@/shared/graphql/types";
import {OnBehalfOf} from "@/shared/composable/security.ts";


export class ClientBasket {

    contact?: Contact
    onBehalfOf: OnBehalfOf
    readonly id: string
    guestId?: string
    etag: string
    displayVatTotals: boolean = true
    paysVat: boolean = true
    isRepresentativeBasket: boolean = false

    items: ClientLineItem[]
    promotionsInput: BasketPromotionsInput
    promotions: PromotionResponse
    validation?: BasketValidation
    cost: BasketCost
    totalItemQuantity: number

    constructor(basketId: string, etag: string, validation?: BasketValidation) {
        this.id = basketId;
        this.etag = etag;
        this.items = [];
        this.validation = validation;
    }

    clone(): ClientBasket {
        const cloned = new ClientBasket(this.id, this.etag, this.validation);

        // Copy primitive properties
        cloned.guestId = this.guestId;
        cloned.displayVatTotals = this.displayVatTotals;
        cloned.paysVat = this.paysVat;
        cloned.isRepresentativeBasket = this.isRepresentativeBasket;
        cloned.totalItemQuantity = this.totalItemQuantity;
        cloned.contact = this.contact;
        cloned.onBehalfOf = this.onBehalfOf;
        cloned.promotionsInput = this.promotionsInput;
        cloned.promotions = this.promotions;
        cloned.cost = this.cost;
        cloned.items = this.items
        return cloned;
    }

}